import { DataSource } from './abstract-data-source';
import { EmployeesDataSource, EmployeeDataType } from './employees-data-source';
import { AbstractDataSourceType } from './abstract-data-source-type';
import { IAllocations } from '@/contracts/AllocationContract';

interface AllocationToEmployeesHash {
    [contractName: string]: EmployeeDataType[];
}

interface AllocationHash {
    [allocationName: string]: AllocationsDataType;
}

export interface AllocationsDataType extends AbstractDataSourceType, IAllocations {}

export class EmployeesToAllocationsDataSource extends DataSource {
    public data: AllocationsDataType[];

    public allocationsToEmployees: AllocationToEmployeesHash = {};
    public allocationsHash: AllocationHash = {};

    public accountIdToAllocation: { [accountId: string]: AllocationsDataType } = {};
    public employeeIdToAllocations: { [employeeId: string]: IAllocations[] } = {};

    constructor(allocations: IAllocations[], employeesDataSource: EmployeesDataSource) {
        super(allocations as AllocationsDataType[]);
        this.data.forEach(allocation => {
            // Calculate Contracts
            if (!this.allocationsToEmployees[allocation.AccountName]) {
                this.allocationsToEmployees[allocation.AccountName] = [];
            }
            const employee = employeesDataSource.employeeIdToEmployee[allocation.EmployeeId];
            if (employee) {
                if (!this.allocationsToEmployees[allocation.AccountName].filter(e => e.Id === employee.Id).length) {
                    this.allocationsToEmployees[allocation.AccountName].push(employee);
                }
            }
            this.allocationsHash[allocation.AccountName] = allocation;

            this.accountIdToAllocation[allocation.AccountId] = allocation;

            if (!this.employeeIdToAllocations[allocation.EmployeeId]) {
                this.employeeIdToAllocations[allocation.EmployeeId] = [];
            }
            this.employeeIdToAllocations[allocation.EmployeeId].push(allocation);
        });
    }
}
